export class NroDocumentoServicio {
    nombreApp = '';
    token = '';
    nroCasilla: string;
    codUsuario: string;

}

